(function ($) {
  function initSearch()
  {
    var $search = document.querySelector('.js-search');
    if ($search == undefined || $search == null) {
      return;
    }

    var $filters = $search.querySelector('.js-filters');

    // Toggle form select
    var $formSelects = document.querySelectorAll('.js-form-select');
    if ($formSelects.length) {
      $formSelects.forEach(function($formSelect) {
        var $formSelectBtn = $formSelect.querySelector('.js-form-select-btn');

        $formSelectBtn.addEventListener('click', function(e) {
          e.preventDefault();
          $formSelect.classList.toggle('is-opened');
        });

        //
        var $formCheckboxInputs = $formSelect.querySelectorAll('.js-form-checkbox-input');
        $formCheckboxInputs.forEach(function($formCheckboxInput) {
          $formCheckboxInput.addEventListener('change', function() {
            var counter = 0;
            $formCheckboxInputs.forEach(function($formCheckboxInput) {
              if ($formCheckboxInput.checked) {
                counter++;
              }
            });
            $formSelectBtn.setAttribute('data-number', counter);
            if (counter > 0) {
              $formSelect.classList.add('is-selected');
            } else {
              $formSelect.classList.remove('is-selected');
            }
          });
        });
      });
    }

    var $btnSaveSearch = document.querySelector('.js-save-search');
    if ($btnSaveSearch) {
      $btnSaveSearch.addEventListener('click', function (e) {
        e.preventDefault();
        this.classList.toggle('is-active');
        window.location.href = ("0" == $($btnSaveSearch).attr('data-user')) ? $($btnSaveSearch).attr('data-login') : $($btnSaveSearch).attr('data-url');
      });
    }

    // Reset filters
    var $formReset = document.querySelector('.js-form-reset');
    $formReset.addEventListener('click', function(e) {
      e.preventDefault();
      window.location.href = $($formReset).attr('data-url');

      // checkboxes
      var $checkedInputs = $filters.querySelectorAll('input[type="checkbox"]');
      $checkedInputs.forEach(function($checkedInput) {
        $checkedInput.checked = false;
      });

      // text inputs
      var $textInputs = $filters.querySelectorAll('input[type="text"]');
      $textInputs.forEach(function($textInput) {
        $textInput.value = '';
      });

      // Select
      $formSelects.forEach(function($formSelect) {
        $formSelect.classList.remove('is-selected', 'is-opened');
        $formSelect.querySelector('.js-form-select-btn').setAttribute('data-number', 0);
      });
    });
  }

  function urlencodeFormData(fd){
    var s = '';
    function encode(s){ return encodeURIComponent(s).replace(/%20/g,'+'); }
    for(var pair of fd.entries()){
        if(typeof pair[1]=='string'){
            s += (s?'&':'') + encode(pair[0])+'='+encode(pair[1]);
        }
    }
    return s;
  }

  function hideFieldset(element)
  {
    $(element).find('input').each(
      function () {
        if (this.checked) {
          $(this).removeAttr("disabled");
        }
      }
    );
  }

  function verifThematic()
  {
    $fieldsetGlobal = $('.fieldset-keywordsglobal');
    $fieldsetBzh = $('.fieldset-keywordsbzh');
    $fieldsetPdl = $('.fieldset-keywordspdl');
    if ($("#territoire-checkbox-0").is(":checked") && $("#territoire-checkbox-1").is(":checked")) {
      $fieldsetBzh.hide(hideFieldset($fieldsetBzh));
      $fieldsetPdl.hide(hideFieldset($fieldsetPdl));
      $fieldsetGlobal.show();
    } else if ($("#territoire-checkbox-0").is(":checked") && $("#territoire-checkbox-1").not(":checked")) {
      $fieldsetBzh.show();
      $fieldsetPdl.hide(hideFieldset($fieldsetPdl));
      $fieldsetGlobal.hide(hideFieldset($fieldsetGlobal));
    } else if ($("#territoire-checkbox-1").is(":checked") && $("#territoire-checkbox-0").not(":checked")) {
      $fieldsetBzh.hide(hideFieldset($fieldsetBzh));
      $fieldsetGlobal.hide(hideFieldset($fieldsetGlobal));
      $fieldsetPdl.show();
    } else {
      $fieldsetBzh.hide(hideFieldset($fieldsetBzh));
      $fieldsetPdl.hide(hideFieldset($fieldsetPdl));
      $fieldsetGlobal.show();
    }
  }

  function returnAjaxSearch(response)
  {
    document.querySelectorAll('.fieldset-keywordsdisable').forEach(function ($fieldset) {
      const inputElement = document.querySelector('.keyword__input');
      if (inputElement) {
        if (inputElement.value.trim() !== '') {
          $($fieldset).show();
       }
      }
    });
    verifThematic();
    $('#search-results').html($(response).find('#search-results').html());

    $('#search-results a.page-numbers').on('click', function(e) {
      e.preventDefault();
      var page = $(this).text();
      launchAjax(page);
    });

    check_folders_bookmarks();
    modalSearch();
    verifySaveSearch();
    App.scroll('#search_form');
  }

  function ajaxSearch()
  {
    var $search = document.querySelector('.filters__form');
    if ($search == undefined || $search == null) {
      return;
    }

    var $inputs = $search.querySelectorAll('input:not(.keyword__input)');
    $inputs.forEach(function (element) {
      $(element).on('change', function () {
        $(element).closest('form').trigger('submit');
      });
    });

    $($search).on('submit', function (element) {
      element.preventDefault();
      launchAjax();
    });
    var $input = document.querySelector('.keyword__input');
    if ($input == undefined || $input == null) {
      launchAjax();
    } else if ($input.value.trim() != '') {
      launchAjax();
    }
  }

  function launchAjax(page)
  {
    var formElement = document.querySelector("#search_form");
    var loader = $('#search-loader');
    var formData = new FormData(formElement);
    formData.set('paged', page || 1);
    $.ajax({
      url: window.ajaxurl,
      type: "GET",
      data: urlencodeFormData(formData),
      beforeSend: function() {
        loader.show();
      },
      complete: function() {
        loader.hide();
      },
    }).done(function (response) {
      returnAjaxSearch(response);
    });
  }

  $(function () {
    initSearch();
    ajaxSearch();
    verifThematic();
  });
})(jQuery);
